import React, { useState, useEffect, useRef } from 'react';
import api from '../service/AxiosInstance';
import { Divider } from 'primereact/divider';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Badge } from 'primereact/badge';
import { Image } from 'primereact/image';
import './DataTable.css';
import { Button } from 'primereact/button';
import { Toolbar } from 'primereact/toolbar';
import { render } from 'preact/compat';
import { FileUpload } from 'primereact/fileupload';
import { Card } from 'primereact/card';

const MaFamille = () => {

    const dt = useRef(null);
    const [famille, setFamille] = useState([]);
    const user_connect_local = localStorage.getItem("user_connect");
    const user_connect = JSON.parse(user_connect_local);


    useEffect(() => {

        api.get("Benef/list/" + user_connect.numcont)
            .then(resp => {
                setFamille((resp.data).filter(f => f.codebenef !== '1'));
            });

    }, []);

    const imageBodyTemplate = (rowData) => {
        return <Image src={`images/photos/${rowData.matribenef}.jpg`} onError={(e) => render(<img src='user_icon.jpg' />)} alt='photo' width="80" height="60" preview className="image" />
        // return <Image src="images/photos/user_icon.jpg" onError={(e) => render(<img src='user_icon.jpg' />)} alt='photo' width="80" height="60" preview className="image" />
    }

    const rightToolbarTemplate = () => {
        return (
            <React.Fragment>
                {/* <FileUpload mode="basic" name="demo" url="./upload.php" chooseLabel='Ajouter une photo' accept="image/*" maxFileSize={1000000} /> */}

                {/* <Button label="Ajouter une photo" icon="pi pi-user" className="p-button-raised p-button-help p-button-text" /> */}
            </React.Fragment>
        )
    }

    const leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                <Image src={`images/photos/${user_connect.matipm}.jpg`} alt="Image  Text" width="200" height="200" preview />
            </React.Fragment>
        )
    }

    return (
        <div>
            <div className="col-12">
                <div className="card">
                    <h3>Ma Famille</h3>
                    {/* <h5>{`Ma Famille - ${user_connect.prenom} ${user_connect.nom}`} </h5> */}
                    <Divider />
                    <div className="datatable-crud-demo">
                        <div className='card'>
                            <Toolbar className="mb-2 mt-2" right={rightToolbarTemplate} left={leftToolbarTemplate} />
                            <DataTable value={famille} ref={dt} size='small'
                                rowHover responsiveLayout='scroll'
                                paginator resizableColumns
                                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                                rows={4} rowsPerPageOptions={[4, 8, 12]}>
                                <Column field="image" header="Photo" body={imageBodyTemplate}></Column>
                                <Column field='matribenef' header='Matricule' sortable ></Column>
                                <Column field='codebenef' header='Type Bénéf.' body={(data) => data.codebenef === '2' ?
                                    "Epoux(e)" : (data.codebenef === '3' ? "Enfant" : (data.codebenef === '1' ? "Participant" : (data.codebenef === '4' ? "Epoux" : (data.codebenef === '5' ? "Ascendant" : "Autre"))))} sortable ></Column>
                                <Column field='prenoms' header='Prénoms' sortable ></Column>
                                <Column field='nom' header='Nom' sortable ></Column>
                                <Column field='adresse' header='Adresse' sortable ></Column>
                                <Column field='ageb' header='Age' sortable align='center' body={(row) => (row.ageb > 20 && row.codebenef == 3) ? <Badge value={row.ageb} severity="danger"></Badge> : <Badge value={row.ageb} severity="success"></Badge>}></Column>
                                <Column field='sexe' header='Sexe' sortable ></Column>
                                <Column field='suspension_benef' header='Etat' body={(row) => row.suspension_benef === 'A' ? <Badge value='Actif' severity="success"></Badge> : <Badge value='Suspendu' severity="danger"></Badge>} sortable ></Column>

                            </DataTable>
                        </div>

                    </div>
                </div>
            </div>
        </div >
    );
}

const comparisonFn = function (prevProps, nextProps) {
    return prevProps.location.pathname === nextProps.location.pathname;
};

export default React.memo(MaFamille, comparisonFn);
